export default __webpack_public_path__ + "static/media/Savant's Pants of Awakening.d1259d49.jpg";